/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Link } from "react-router-dom";
import { SxProps, Theme } from "@mui/material";
import Button from "@mui/material/Button";

export interface CommandBarButtonProps {
    caption: string;
    icon: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
    href?: string;
    to?: string;
    hidden?: boolean;
    children?: React.ReactNode;
    sx?: SxProps<Theme>;
}

export default function CommandBarButton(props: CommandBarButtonProps) {
    return (
        <Button
            variant="text"
            color="inherit"
            aria-label={props.caption}
            sx={[{ textTransform: "none" }, !!props.hidden && { display: "none" }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
            startIcon={props.icon}
            onClick={props.onClick}
            disabled={props.disabled}
            {
                ...(
                    !!props.href ? {
                        component: "a",
                        href: props.href,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    } : {}
                )
            }
            {
                ...(
                    !!props.to ? {
                        component: Link,
                        to: props.to,
                    } : {}
                )
            }
        >
            {props.caption}
            {props.children}
        </Button>
    );
}
